export default "__VITE_ASSET__Cs0F1ly3__"